<template>
  <div>
    <div v-if="loading">Analyzing...</div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import {
  detectFaceLandmarks,
  LandmarkCanvas,
} from "@/facemorpher/facelandmarks.js";

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      landmarks: null,
      loading: true,
    };
  },
  methods: {
    getLandmarks() {
      return this.landmarks;
    },
  },
  watch: {
    src: {
      immediate: true,
      handler(newValue) {
        this.loading = true;
        const image = new Image();
        image.src = newValue;
        image.onload = async () => {
          const canvas = this.$refs.canvas;
          const context = canvas.getContext("2d");
          canvas.setAttribute("width", image.width);
          canvas.setAttribute("height", image.height);
          context.drawImage(image, 0, 0, image.width, image.height);
          this.loading = false;
          // use landmarks of the first detected face
          const faces = await detectFaceLandmarks(image);
          let landmarks = {
            imageHeight: image.width,
            imageWidth: image.height,
            positions: [
              {x: 18, y:150},{x: 23, y:184},{x: 28, y:215},{x: 35, y:241},{x: 45, y:268},{x: 61, y:288},{x: 82, y:299},{x: 108, y:309},{x: 146, y:314},{x: 181, y:306},{x: 206, y:296},{x: 224, y:285},{x: 241, y:263},{x: 251, y:237},{x: 256, y:210},{x: 262, y:180},{x: 263, y:148},{x: 45, y:123},{x: 59, y:113},{x: 77, y:109},{x: 94, y:110},{x: 109, y:114},{x: 168, y:114},{x: 182, y:109},{x: 199, y:107},{x: 218, y:111},{x: 232, y:120},{x: 140, y:147},{x: 140, y:168},{x: 141, y:188},{x: 140, y:206},{x: 124, y:220},{x: 132, y:223},{x: 141, y:225},{x: 152, y:222},{x: 160, y:220},{x: 69, y:144},{x: 80, y:139},{x: 94, y:139},{x: 108, y:146},{x: 97, y:151},{x: 81, y:151},{x: 170, y:145},{x: 183, y:136},{x: 198, y:136},{x: 209, y:143},{x: 198, y:149},{x: 182, y:148},{x: 106, y:263},{x: 120, y:256},{x: 134, y:250},{x: 142, y:252},{x: 150, y:249},{x: 165, y:257},{x: 179, y:262},{x: 167, y:269},{x: 155, y:274},{x: 142, y:276},{x: 131, y:274},{x: 118, y:271},{x: 108, y:262},{x: 131, y:260},{x: 142, y:260},{x: 153, y:260},{x: 176, y:262},{x: 154, y:261},{x: 143, y:262},{x: 131, y:262},
            ],
          };

          // Three lines are commented out - use them to output a positions array
          //let str = '';
          if (Array.isArray(faces) && faces.length > 0) {
            const positions = [];
            faces[0].landmarks.positions.forEach((position) => {
              positions.push({x: position.x, y: position.y})
              //str += `{x: ${Math.floor(position.x)}, y:${Math.floor(position.y)}},`;
            });
            //console.log(str);

            landmarks = {
              imageHeight: faces[0].landmarks.imageHeight,
              imageWidth: faces[0].landmarks.imageWidth,
              positions: positions,
            };
          }

          new LandmarkCanvas(await landmarks, canvas);
          this.landmarks = landmarks;
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
canvas {
  width: 640px;
}
</style>
